var _defs, _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUiOpenseaPfp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ui_opensea_pfp",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_378",
    "data-name": "Rectangle 378",
    width: 25.757,
    height: 18.213,
    fill: "#fff000"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_83",
    "data-name": "Ellipse 83",
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#222"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_19_1",
    "data-name": "Component 19 \\u2013 1",
    transform: "translate(9 12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_380",
    "data-name": "Rectangle 380",
    width: 30,
    height: 24,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1055",
    "data-name": "Group 1055",
    transform: "translate(2 2.999)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1090",
    "data-name": "Path 1090",
    d: "M9.835,6.107a4.16,4.16,0,1,0,5.883,0,4.16,4.16,0,0,0-5.883,0",
    transform: "translate(0.102 0.058)",
    fill: "#fff000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1091",
    "data-name": "Path 1091",
    d: "M6.334,2.667l-.068.068.068-.068",
    transform: "translate(0.074 0.032)",
    fill: "#fff000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1092",
    "data-name": "Path 1092",
    d: "M19.319,2.863l.062.062-.062-.062",
    transform: "translate(0.229 0.034)",
    fill: "#fff000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1093",
    "data-name": "Path 1093",
    d: "M6.092,2.908l0,0,0,0-.005.005",
    transform: "translate(0.072 0.034)",
    fill: "#fff000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1094",
    "data-name": "Path 1094",
    d: "M6.138,15.139l-.072-.072.072.072",
    transform: "translate(0.072 0.178)",
    fill: "#fff000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1095",
    "data-name": "Path 1095",
    d: "M19.349,15.515l6.408-6.409-6.3-6.3.037.038-.065-.066h0l-.114-.115h0a9.107,9.107,0,0,0-12.884.005l-.01.009,0,0-.008.007h0l-.251.251c.018-.018.038-.039.065-.065l-.068.068L0,9.107l6.3,6.3-.037-.037.082.081.007.008.091.091h0a9.106,9.106,0,0,0,12.885-.005l0,0,.01-.01h0l.012-.011m.174-.175.076-.075-.076.075m-6.645.766a7,7,0,1,1,7-7,7,7,0,0,1-7,7",
    fill: "#fff000"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUiOpenseaPfp);
export default __webpack_public_path__ + "static/media/ui_opensea_PFP.219d0b74c6a204f34a283537b5296de8.svg";
export { ForwardRef as ReactComponent };